import axios from "axios";
import React, { useEffect, useState, useContext } from "react";

import Contexto from '../comun/Contexto';
import Pagina from "../comun/Pagina";
import Mapa from "./Mapa";
import mundo from "../../img/mundo.png";
import Boton from "../comun/Boton";
import { PanelInfoSitio } from "./ConsultaPorSitio";

import datosDummy from "./sismos_consulta_centro_poblado.json"

const CPSMapa=(props)=> {
    /* Contexto */
    const { urlBaseRest } = useContext(Contexto);

    /* Estado */
    const[datos, setDatos] = useState([{}]);    

    /* Efectos */
    useEffect(()=>{
        const traerDatos = async(url) => {
			const res = await axios(url);
            setDatos(res.data);
		};
        traerDatos(urlBaseRest + "sismos_consulta_centro_poblado/"+props.idCentroPoblado);
        //setDatos(datosDummy);
    }, []); 
       
    /* Render */  
    return(
        <Pagina 
        titulo="Consulta por sitio"
        imgSrc={mundo}
        imgAlt="Consulta por sitio" 
        handleSubmit={function(){}}       
        explicacion={
            <React.Fragment> 
            Las estrellas representan los epicentros de los sismos que han tenido alguna intensidad relacionada con el sitio seleccionado.
            Al hacer clic sobre cualquier epicentro se puede conocer la información detallada del sismo.
            </React.Fragment>
        }
        contenidoPrincipal= {  
            <div style={{display: "flex", flexDirection:"column", flexGrow: 1, height:"100%"}}>
                
                <PanelInfoSitio nombreMunRef ={props.nombreMunRef} nombreCPRef={props.nombreCPRef}/>
                
                <Mapa datos={datos} idCP={props.idCentroPoblado}></Mapa>

                <div style={{width:"100%", textAlign:"center"}}>
                    <Boton onClick={props.irAConsultaTabla} texto="Volver a resultados"/>
                    &nbsp;
                    <Boton onClick={props.irAConsultaSelCP} texto="Nueva consulta"/>
                </div>
            </div>            
        }
        />
    )
}

export default CPSMapa;